import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AdminServiceService } from '../../service/admin-service.service';

@Component({
  selector: 'app-reviewStat',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss'],
})
export class ReviewComponent implements OnInit, OnDestroy {
  public calification = 5;
  public reviews = undefined;
  public totalPages = undefined;
  private _page = 1;
  public resourceId = '';
  public view = 'all';
  private _adminSrc: Subscription;
  private _state = '1';

  constructor(
    private adminSv: AdminServiceService
  ) { }

  ngOnInit() {
    this._adminSrc = this.adminSv.emitApprove.subscribe(() => {
      this.getReviews();
    })
    this.getReviews();
  }

  ngOnDestroy(): void {
    this._adminSrc.unsubscribe();
  }

  async getReviews(){
    try{
      const res = await this.adminSv.getReviews('index', this._page, this.resourceId, this._state);
      this.reviews = res.data;
      if(!this.totalPages){
        this.totalPages = res.meta.last_page;
      }
    }catch(err){
      console.error(err);
      
    }
  }

  async setReviewType(ev){
    const value = ev.detail.value;
    value === 'all' ? this._state = '1' : this._state = '0';
    await this.getReviews();
  }

  setResource(resourceId){
    this.resourceId = resourceId;
    this.getReviews();
  }
}
